import {
  SpectrumEnterprise,
  SpectrumEnterpriseService,
} from "api/interfaces/reportInterface.interface";
import { TableColumnsType } from "antd";
import { ReportTable } from "components/atoms/table/AntdTable";
import { formatNumber } from "utils/functions";

interface Props {
  isMap: boolean;
  enterprises: SpectrumEnterprise;
}

export default function Enterprises({ isMap, enterprises }: Props) {
  const columns: TableColumnsType<SpectrumEnterpriseService> = [
    {
      title: "Name",
      render: (value, row) => row.displayName,
    },
    {
      title: "Type",
      render: (value, row) => row.type,
    },
    {
      title: "Total",
      render: (value, row) => formatNumber(row.quantity),
    },
    {
      title: "Used",
      render: (value, row) => formatNumber(row.used),
    },
  ];
  return (
    <div>
      <h5 className="title">Active Services Usage</h5>
      <ReportTable dataSource={enterprises.services} columns={columns} />
    </div>
  );
}
